import {Typography} from "@mui/material";
import React from "react";

const DefaultElement = ({attributes,children})=>(<Typography component={'p'} {...attributes}>{children}</Typography>);

export default DefaultElement;